import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	emptyHeader: {
		id: 'snippets.snippet-tab.empty.header',
		defaultMessage: 'No templates found',
		description:
			'This is the headline that shows when no snippets match the selected category or filters',
	},
	emptyDescription: {
		id: 'snippets.snippet-tab.empty.description',
		defaultMessage: 'Try selecting a different category to see more templates.',
		description:
			'This is the description that shows when no snippets match the selected category or filters',
	},
	myTemplatesEmptyHeader: {
		id: 'snippets.snippet-tab.empty.my-templates.header',
		defaultMessage: 'Make almost anything a block template',
		description: 'Empty state headline when the user has no block templates in My Templates',
	},
	myTemplatesEmptyDescription: {
		id: 'snippets.snippet-tab.empty.my-templates.description',
		defaultMessage:
			'Highlight page content, and select "Create Block Template" to save it here in <categoryName>My Templates</categoryName>.{br}Type "/templatename" to insert into a page.',
		description: 'Empty state description for My Templates when the user has no templates',
	},
	myTemplatesEmptyPrimaryAction: {
		id: 'snippets.snippet-tab.empty.my-templates.primary-action',
		defaultMessage: 'Create template',
		description: 'Button label to open the create template modal from the My Templates empty state',
	},
	favoritesEmptyHeader: {
		id: 'snippets.snippet-tab.empty.favorites.header',
		defaultMessage: "You haven't starred a template yet",
		description: 'Empty state headline when the user has no favorites',
	},
	favoritesEmptyDescription: {
		id: 'snippets.snippet-tab.empty.favorites.description',
		defaultMessage:
			'Star a template to save it here. Type "/templatename" to quickly insert it into a page.',
		description: 'Empty state description for Favorites when the user has no starred templates',
	},
	favoritesEmptyPrimaryAction: {
		id: 'snippets.snippet-tab.empty.favorites.primary-action',
		defaultMessage: 'Explore templates',
		description: 'Button label to switch to exploring all templates',
	},
});
